// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_mIv","cls2":"ProfilePdfPackCard-cls2__8v ProfilePdfPackCard-cls1_mIv"};